import React, { useMemo, useState } from "react";
import PaginationControl from "./PaginationControl";

const AnnualLoginHistory = ({
  dataUser,
  // pagination
  annualPage,
  annualPerPage,
  setAnnualPage,
  setAnnualPerPage,
  annualTotalPages,
  annualOffset,
  annualPaginated,

  // ui
  isLoading,
  handleResetFilter,
  handleAnnualPageChange,

  // helper
  mapppingColorForBGBadgeRole,
  selectedRole,
  setSelectedRole,
}) => {
  const [startDate, setStartDate] = useState("");
  const [tempStartDate, setTempStartDate] = useState(startDate || "");
  const [endDate, setEndDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState(endDate || "");
  const [searchName, setSearchName] = useState("");

  const Roles = [
    "admin",
    "super-user",
    "user",
    "tls",
    "mo",
    "sales",
    "operational",
    "cs-online",
  ];

  const todayStr = new Date().toISOString().split("T")[0];

  const isDateRangeValid = Boolean(startDate && endDate);

  const filteredAnnualPaginated = useMemo(() => {
    const q = searchName.trim().toLowerCase();

    if (!isDateRangeValid) {
      return annualPaginated.filter((history) => {
        if (q && !history.name?.toLowerCase().includes(q)) {
          return false;
        }
        if (selectedRole && history.role !== selectedRole) {
          return false;
        }
        return true;
      });
    }

    const startTs = new Date(`${startDate}T00:00:00`).getTime();
    const endTs = new Date(`${endDate}T23:59:59`).getTime();

    return annualPaginated.filter((history) => {
      if (q && !history.name?.toLowerCase().includes(q)) {
        return false;
      }
      if (selectedRole && history.role !== selectedRole) {
        return false;
      }

      const userLogins = dataUser.filter(
        (u) => u.user?.name === history.name && u.logged_in_at
      );

      if (userLogins.length === 0) return false;

      return userLogins.some((u) => {
        const ts = new Date(u.logged_in_at.replace(" ", "T")).getTime();
        return ts >= startTs && ts <= endTs;
      });
    });
  }, [
    annualPaginated,
    dataUser,
    searchName,
    startDate,
    endDate,
    isDateRangeValid,
    selectedRole,
  ]);

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0 pb-0 pt-3">
        <h5 className="m-0 fw-bold">Riwayat Jumlah Login Tahunan</h5>
      </div>

      <div className="card-body">
        <div className="mb-3">
          <div className="border rounded p-3 bg-white">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label small text-muted mb-1">
                  Cari Nama User
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ketik nama..."
                  value={searchName}
                  onChange={(e) => {
                    setSearchName(e.target.value);
                    setAnnualPage(1);
                  }}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label small text-muted mb-1">
                  Tanggal Mulai
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={todayStr}
                  value={tempStartDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setTempStartDate(value);
                    setAnnualPage(1);

                    if (value > todayStr) {
                      alert("Tanggal akhir tidak boleh melebihi hari ini");
                      return;
                    }

                    // commit HANYA kalau dua-duanya terisi
                    if (value && tempEndDate) {
                      setStartDate(value);
                      setEndDate(tempEndDate);
                    }
                  }}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label small text-muted mb-1">
                  Tanggal Akhir
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={todayStr}
                  value={tempEndDate}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value > todayStr) {
                      alert("Tanggal akhir tidak boleh melebihi hari ini");
                      return;
                    }

                    setTempEndDate(value);
                    setAnnualPage(1);

                    // commit HANYA kalau dua-duanya terisi
                    if (tempStartDate && value) {
                      setStartDate(tempStartDate);
                      setEndDate(value);
                    }
                  }}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Role</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedRole}
                  onChange={(e) => {
                    setSelectedRole(e.target.value);
                    setAnnualPage(1);
                  }}
                >
                  <option value="">Semua Role</option>
                  {Roles.map((role) => (
                    <option key={role} value={role}>
                      {role}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setTempStartDate("");
                    setTempEndDate("");
                    setSelectedRole("");
                    setAnnualPage(1);
                    handleResetFilter();
                  }}
                >
                  <i className="fa fa-undo me-1" />
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="fw-semibold">Daftar Login</span>
          <div className="d-flex align-items-center gap-2">
            <span className="small text-muted">Data per halaman</span>
            <select
              className="form-select form-select-sm w-auto"
              value={annualPerPage}
              onChange={(e) => {
                setAnnualPerPage(parseInt(e.target.value));
                setAnnualPage(1);
              }}
            >
              <option value="10">10 Data</option>
              <option value="50">50 Data</option>
              <option value="100">100 Data</option>
            </select>
          </div>
        </div>

        <div className="table-responsive scrollable-container">
          <table className="table table-hover align-middle text-nowrap">
            <thead className="table-light">
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Role</th>
                <th>Jumlah Login</th>
                <th>Tanggal Awal Login</th>
                <th>Login Terakhir</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <div className="spinner-border text-primary mb-2" />
                    <div className="text-muted small">Memuat data...</div>
                  </td>
                </tr>
              ) : filteredAnnualPaginated.length > 0 ? (
                filteredAnnualPaginated.map((history, idx) => {
                  const userLogins = dataUser.filter(
                    (u) => u.user?.name === history.name && u.logged_in_at
                  );
                  const sortedLogins = [...userLogins].sort(
                    (a, b) =>
                      new Date(a.logged_in_at) - new Date(b.logged_in_at)
                  );
                  const firstLogin = sortedLogins[0]?.logged_in_at;
                  const lastLogin =
                    sortedLogins[sortedLogins.length - 1]?.logged_in_at;

                  return (
                    <tr key={history.name}>
                      <td>{annualOffset + idx + 1}</td>
                      <td>{history.name}</td>
                      <td>
                        <span
                          className={`badge ${
                            mapppingColorForBGBadgeRole[history.role] ||
                            "bg-secondary"
                          } text-white`}
                        >
                          {history.role}
                        </span>
                      </td>
                      <td>{history.jumlahLogin ?? 0}</td>
                      <td>
                        {firstLogin
                          ? new Date(firstLogin).toLocaleString("id-ID", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "-"}
                      </td>
                      <td>
                        {lastLogin
                          ? new Date(lastLogin).toLocaleString("id-ID", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "-"}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    Tidak ada data ditemukan
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <PaginationControl
          currentPage={annualPage}
          totalPages={annualTotalPages}
          onPageChange={handleAnnualPageChange}
        />
      </div>
    </div>
  );
};

export default AnnualLoginHistory;
